import React from "react";
import TextBox from "./TextBox";
import "./PaginationV2.css";

type Props = {
  canPreviousPage: boolean;
  canNextPage: boolean;
  pageCount: number;
  gotoPage: (page: number) => void;
  nextPage: () => void;
  previousPage: () => void;
  pageIndex: number;
  totalElement: number;
  elementPerPage: number;
  style?: React.CSSProperties;
};

export default function PaginationV2({
  canPreviousPage,
  canNextPage,
  pageCount,
  gotoPage,
  nextPage,
  previousPage,
  pageIndex,
  totalElement,
  elementPerPage,
  style = {},
}: Props) {
  const start = pageIndex * elementPerPage;
  const end = Math.min(start + elementPerPage, totalElement);
  const label = `${start}-${end} of ${totalElement}`;
  return (
    <div className="pagination-v2" style={{ ...style }}>
      <label>{label}</label>
      <button onClick={previousPage} disabled={!canPreviousPage}>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.25 9.99998L12.9167 16.6666L12.9167 3.33331L6.25 9.99998Z"
            fill={canPreviousPage ? "#F7A246" : "#313131"}
          />
        </svg>
      </button>

      <button onClick={nextPage} disabled={!canNextPage}>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.75 10L7.08333 3.33336L7.08333 16.6667L13.75 10Z"
            fill={canNextPage ? "#F7A246" : "#313131"}
          />
        </svg>
      </button>
    </div>
  );
}
